"use client";

interface InquiryPillsProps {
  onSelectTopic: (topic: string) => void;
}

const topics = [
  { id: "demo", label: "Demo", value: "demo" },
  { id: "assessment", label: "Assessment", value: "assessment" },
  { id: "delivery", label: "Delivery", value: "delivery" },
  { id: "stabilization", label: "Stabilization", value: "stabilization" },
  { id: "partner", label: "Partner/Alliance", value: "partner" },
  { id: "architect", label: "Architect Network", value: "architect" },
];

export default function InquiryPills({ onSelectTopic }: InquiryPillsProps) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-4">
      {topics.map((topic) => (
        <button
          key={topic.id}
          onClick={() => onSelectTopic(topic.value)}
          className="px-4 py-2 rounded-full bg-neutral-800 border border-white/10 text-neutral-300 text-sm hover:border-blue-500/30 hover:bg-white/5 transition-all"
        >
          {topic.label}
        </button>
      ))}
    </div>
  );
}